module.exports = __webpack_public_path__ + "img/44.169859b8.jpg";